import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { loginService } from "./services/LoginService";
import Login from './containers/Login/Login'
import Products from "./containers/Products/Products";
import ImportProducts from "./containers/ImportProducts/ImportProducts";
import ImportReceptions from "./containers/ImportReceptions/ImportReceptions";
import SearchProduct from "./containers/SearchProduct/SearchProduct";
import ProductDetails from "./containers/ProductDetails/ProductDetails";
import Receptions from "./containers/Receptions/Receptions";
import ReceptionDetails from "./containers/ReceptionDetails/ReceptionDetails";
import { ToastContainer } from 'react-toastify';
import CreateList from "./containers/Lists/CreateList";
import ReadyToSend from './containers/Lists/ReadyToSend'
import OriginalCreateList from "./containers/CreateList/originalcreatelist"
import OfertingLists from "./containers/Lists/OfertingLists";
// import OfertingList from "./containers/Lists/OfertingList ";
import OfertedProducts from "./containers/Bidding/OfertedProducts";
import ListDetails from "./containers/Bidding/ListDetails";
import OfertedLists from "./containers/Lists/OfertedLists";
import 'react-toastify/dist/ReactToastify.css';
import FinalValidation from "./containers/Lists/FinalValidation";
import AddProvider from "./containers/Providers/AddProvider";
import Providers from "./containers/Providers/Providers";
import ArchivedLists from "./containers/Lists/ArchivedLists";
import HiddenProducts from "./containers/Bidding/HiddenProducts";
import RegisteredOffers from "./containers/Bidding/RegisteredOffers";
import NoOffers from './containers/NoOffers/NoOffers'
import SublistView from "./containers/Lists/SublistView";
import Product from "./containers/Product/Product";
import ManualProcessing from "./containers/Lists/ManualProcessing";
import Assignments from "./containers/Lists/Assignments";
import AssignedProducts from "./containers/Lists/AssignedProducts";
function App() {
  return (
    <div className="App">
      <Suspense fallback={<div>Loading...</div>}>
        <Router>
          <Routes>
            <Route exact path="/login" element={<Login />} />

            // Admin Routes
            <Route exact path="/products" element={<AdminRoute><Products /></AdminRoute>} />

            <Route exact path="/search-product" element={<AdminRoute><SearchProduct /></AdminRoute>} />

            <Route exact path="/import-products" element={<AdminRoute><ImportProducts /></AdminRoute>} />
            <Route exact path="/import-receptions" element={<AdminRoute><ImportReceptions /></AdminRoute>} />

            <Route path="/product/:id" element={<AdminRoute><ProductDetails /></AdminRoute>} />
            <Route path="/product-details/:id" element={<AdminRoute><Product /></AdminRoute>} />

            <Route path="/receptie/:id" element={<AdminRoute><ReceptionDetails /></AdminRoute>} />

            <Route exact path="/receptii" element={<AdminRoute><Receptions /></AdminRoute>} />

            <Route exact path="/liste" element={<AdminRoute><OriginalCreateList /></AdminRoute>} />

            <Route path="/liste-necesar" element={<AdminRoute><CreateList /></AdminRoute>} />
            <Route path="/liste-necesar/:id" element={<AdminRoute><CreateList /></AdminRoute>} />
            <Route exact path="/gata-de-trimis" element={<AdminRoute><ReadyToSend /></AdminRoute>} />

            <Route exact path="/liste-in-ofertare" element={<AdminRoute><OfertingLists /></AdminRoute>} />

            <Route exact path="/liste-ofertate" element={<AdminRoute><OfertedLists /></AdminRoute>} />
            <Route exact path="/procesare-manuala" element={<AdminRoute><ManualProcessing /></AdminRoute>} />
            <Route exact path="/vezi-atribuiri/:id" element={<AdminRoute><Assignments /></AdminRoute>} />

            <Route exact path="/liste-arhivate" element={<AdminRoute><ArchivedLists /></AdminRoute>} />

            <Route path="/adauga-furnizor" element={<AdminRoute><AddProvider /></AdminRoute>} />
            <Route path="/adauga-furnizor/:id" element={<AdminRoute><AddProvider /></AdminRoute>} />
            <Route exact path="/furnizori" element={<AdminRoute><Providers /></AdminRoute>} />
            <Route path="/atribuiri/:id/furnizor/:supplier_id" element={<AdminRoute> <AssignedProducts /> </AdminRoute>} />
            <Route exact path="/liste-ofertate/verificare-finala/:id" element={<AdminRoute><FinalValidation /></AdminRoute>} />
            <Route exact path="/lista-ofertata/verificare-finala/:id" element={<LegacyFinalValidationRedirect />} />

            <Route exact path="/liste-in-ofertare/vezi-oferte/:id" element={<AdminRoute><ListDetails /></AdminRoute>} />
            {/* <Route exact path="/liste-in-ofertare/:id" element={<OfertingList />} /> */}
            <Route path="/lists/:listId/products/:productId" element={<AdminRoute><SublistView /></AdminRoute>} />


            // Supplier Routes
            <Route exact path="/produse-ofertare/:id" element={<SupplierRoute><OfertedProducts /></SupplierRoute>} />

            <Route exact path="/produse-ascunse/:id" element={<SupplierRoute><HiddenProducts /></SupplierRoute>} />

            <Route exact path="/oferte-inregistrate/:id" element={<SupplierRoute><RegisteredOffers /></SupplierRoute>} />
            <Route exact path="/fara-oferte" element={<SupplierRoute><NoOffers /></SupplierRoute>} />

          </Routes>
        </Router>
        <ToastContainer autoClose={1000} position="top-center" />

      </Suspense>
    </div>
  );
}

const SupplierRoute = ({ children }: { children: JSX.Element }) => {
  return loginService.loggedIn() ? (
    loginService.isSupplier() ? (
      children
    ) : (
      loginService.isAdmin() ? (
        <Navigate
          to={{
            pathname: '/products',
          }}
        />
      ) : (
        <Navigate
          to={{
            pathname: '/login',
          }}
        />
      )
    )
  ) : (
    <Navigate
      to={{
        pathname: '/login',
      }}
    />
  )
};

const AdminRoute = ({ children }: { children: JSX.Element }) => {
  return loginService.loggedIn() ? (
    loginService.isAdmin() ? (
      children
    ) : (
      loginService.isSupplier() ? (
        <Navigate
          to={{
            pathname: '/fara-oferte',
          }}
        />
      ) : (
        <Navigate
          to={{
            pathname: '/login',
          }}
        />
      )
    )
  ) : (
    <Navigate
      to={{
        pathname: '/login',
      }}
    />
  )
};

const LegacyFinalValidationRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/liste-ofertate/verificare-finala/${id}`} replace />;
};

export default App;
